import PremiumPlayerInitializer from "shared/initializers/premium_player_initializer";
import TelcoHeaderEnrichment from "shared/initializers/telco_header_enrichment";
import { LocationMediator } from "shared/vidio_helpers";
import { ApiKey } from "commons/ApiKey/ApiKey";
import BrowserHelper from "shared/utilities/browser_helper";
import BannerAd from "components/shared/BannerAd/BannerAd";
import { BugsnagAdapter } from "commons/BugsnagAdapter";

window.KLYUserDataExchange = require('components/shared/KLYUserDataExchange/KLYUserDataExchange').default;
export default class EmbedInteractionStatus {
  static init() {
    let href = LocationMediator.href();
    let queryParams = new URLSearchParams(LocationMediator.search());

    return this.requestAuth(queryParams).finally(() => {
      if (this.isThroughHeProcess(href, queryParams)) {
        this.processTelcoEnrichment();
      } else {
        this.getStatus(false);
      }
    });
  }

  static requestAuth(queryParams) {
    return new Promise((resolve) => {
      if (
        queryParams.get("live_chat") === "true" &&
        queryParams.get("enable_websocket") === "true"
      ) {
        resolve(ApiKey.getApiKey());
      } else {
        resolve();
      }
    });
  }

  static processTelcoEnrichment() {
    TelcoHeaderEnrichment.process(
      function () {
        this.getStatus(true);
      }.bind(this)
    );
  }

  static setupTelcoHeaderEnrichment() {
    return new TelcoHeaderEnrichment();
  }

  static isThroughHeProcess(url, queryParams) {
    return (
      url.indexOf("/embed") >= 0 &&
      queryParams.get("header_enrichment") === "true"
    );
  }

  static getStatus(bypass_varnish = false) {
    $.ajax({
      url: this.decideInteractionPath(bypass_varnish),
      dataType: "json",
      method: "GET",
      headers: { "X-Auth-Prefer": "AccessToken" },
    }).done(
      function (data) {
        this.onInteractionSuccess(data);
      }.bind(this)
    );
  }

  static decideInteractionPath(bypass_varnish = false) {
    const defaultPath = "/interactions.json";
    const livestreamingId = this.extractLivestreamingId();

    const temp = {};

    if (bypass_varnish === false && livestreamingId === null) {
      return defaultPath;
    }

    if (bypass_varnish == true) {
      temp["varnish_bypass"] = true;
    }

    if (livestreamingId != null) {
      temp["livestreaming_id"] = livestreamingId;
    }

    const params = new URLSearchParams(temp).toString();
    return [defaultPath, params].join("?");
  }

  static extractLivestreamingId() {
    const regex = /live\/(\d+)/i;
    const pathName = BrowserHelper.pathName();
    const match = pathName.match(regex);
    const livestreamingId = match && match[1];

    return livestreamingId;
  }

  static onInteractionSuccess(data) {
    window.isUserSignedIn = Object.keys(data.current_user || {}).length > 0;
    window.currentUser = data.current_user;

    var user = Object.assign({}, data.user_he, data.current_user);

    this.setCsrfToken(data);

    this.setVisitorGender(data.current_visitor);
    this.setVisitorDevice(data.current_visitor);
    this.setMeta(user);
    this.setUserGenderSegment({
      user_gender: user.user_gender,
      classification: user.classification,
    });
    this.getShowStream(user);
    BannerAd.setup();
    this.initializeChatComponent(data.capabilities);
  }

  static newDiscussion() {
    return import(
      /* webpackChunkName: "discussion" */ "shared/components/discussion"
    )
      .then((Discussion) => {
        return new Discussion.default().init();
      })
      .catch((e) => {
        BugsnagAdapter.notify("Embed::Discussion", e);
      });
  }

  static newPinMessage() {
    return import(
      /* webpackChunkName: "pin-message" */ "shared/components/pin_message"
    )
      .then((PinMessage) => {
        return new PinMessage.default().init();
      })
      .catch((e) => {
        BugsnagAdapter.notify("Embed::PinMessage", e);
      });
  }

  static initializeChatComponent({ can_chat }) {
    const chatEnableDOM = document.querySelector(
      ".livestreaming-discussion-enable"
    );
    const chatDisableDOM = document.querySelector(
      ".livestreaming-discussion-disable"
    );

    if (can_chat) {
      chatDisableDOM && chatDisableDOM.classList.add("hide");
      chatEnableDOM && chatEnableDOM.classList.remove("hide");

      EmbedInteractionStatus.newDiscussion();
      EmbedInteractionStatus.newPinMessage();
    }
  }

  static getShowStream(currentUser) {
    let initializer = EmbedInteractionStatus.setupPremiumPlayerInitializer(
      currentUser
    );
    initializer.initialize();
  }

  static setupPremiumPlayerInitializer(currentUser) {
    return new PremiumPlayerInitializer(currentUser);
  }

  static setUserGenderSegment(options) {
    if (window.kmklabs && window.kmklabs.gtm) {
      window.kmklabs.gtm.classification = options.classification;
      window.kmklabs.gtm.user_gender = options.user_gender;
    }
  }

  static setCsrfToken(data) {
    if (data.current_user.token !== undefined) {
      $('meta[name="csrf-token"]').attr("content", data.current_user.token);
    }
  }

  static setMeta(user) {
    $('meta[name="current-username"]').attr("content", user.username);
    $('meta[name="current-user-id"]').attr("content", user.user_id);

    if (window.kmklabs) {
      if (!window.kmklabs.gtm.user_name) {
        window.kmklabs.gtm.user_name = user.username;
      }
      if (!window.kmklabs.gtm.user_id) {
        window.kmklabs.gtm.user_id = user.user_id;
      }

      if(!window.kmklabs.gtm.user_full_name){
        window.kmklabs.gtm.user_full_name = user.full_name;
      }

      if(!window.kmklabs.gtm.user_birthdate){
        window.kmklabs.gtm.user_birthdate = user.birthdate;
      }

      if(!window.kmklabs.gtm.ue){
        window.kmklabs.gtm.ue = window.KLYUserDataExchange.encrypt(user.email);
      }

      if(!window.kmklabs.gtm.pn){
        window.kmklabs.gtm.pn = window.KLYUserDataExchange.encrypt(user.phone);
      }
    }

    if (window.kmklabs && window.kmklabs.ads) {
      window.kmklabs.ads.age = user.age || "";
      window.kmklabs.ads.active_sub = (
        user.has_active_subscription == true
      ).toString();
      window.kmklabs.ads.device_brand = user.device_brand || "";
      window.kmklabs.ads.device_model = user.device_model || "";
      window.kmklabs.ads.sub_package = user.sub_package || "";
    }
  }

  static setVisitorGender(visitor = {}) {
    if (window.isUserSignedIn) return;

    if (window.kmklabs && window.kmklabs.gtm) {
      window.kmklabs.gtm.user_gender = visitor.gender;
    }
  }

  static setVisitorDevice(visitor = {}) {
    if (window.isUserSignedIn) return;

    if (window.kmklabs && window.kmklabs.ads) {
      window.kmklabs.ads.device_brand = visitor.device_brand || "";
      window.kmklabs.ads.device_model = visitor.device_model || "";
    }
  }
}
